import React from 'react'
import ComputerSlotForm from './ComputerSlotForm'

export default function ComputerCreateSlotPage ({ box, onFinishFailed, onFinish, loading }) {
  return (
    <ComputerSlotForm box={box} onFinishFailed={onFinishFailed} onFinish={onFinish} loading={loading} />
  )
}
